import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionWhereKeepPlantsPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-light-condition')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionWhereKeepPlants.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionWhereKeepPlants.apartment'),
          value: 'apartment',
        },
        {
          text: t('pages.onboarding.questionWhereKeepPlants.houseWithGarden'),
          value: 'house_with_garden',
        },
        {
          text: t('pages.onboarding.questionWhereKeepPlants.officeSpace'),
          value: 'office_space',
        },
        {
          text: t('pages.onboarding.questionWhereKeepPlants.balconyPatio'),
          value: 'balcony_patio',
        },
        {
          text: t('pages.onboarding.questionWhereKeepPlants.indoorOnly'),
          value: 'indoor_only',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
